'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _iconBase = require('../icon-base');

var _iconBase2 = _interopRequireDefault(_iconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AdpTheBridge = function (_React$Component) {
  _inherits(AdpTheBridge, _React$Component);

  function AdpTheBridge() {
    _classCallCheck(this, AdpTheBridge);

    return _possibleConstructorReturn(this, (AdpTheBridge.__proto__ || Object.getPrototypeOf(AdpTheBridge)).apply(this, arguments));
  }

  _createClass(AdpTheBridge, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _iconBase2.default,
        this.props,
        _react2.default.createElement(
          'g',
          null,
          _react2.default.createElement('path', { d: 'M446.712 11.288C199.304 11.288 0 210.59 0 458c0 130.578 54.98 247.408 144.322 329.878 0 0 6.872 48.106-6.872 103.086-6.872 48.106-27.49 89.342-48.106 130.576 0 6.872 0 13.744 13.746 6.872 20.618-13.746 89.342-54.98 116.832-75.596 41.234-34.362 75.598-75.596 103.088-68.726 48.108 13.746 68.724 20.616 123.704 20.616 247.408 0 446.712-199.302 446.712-446.712S694.124 11.282 446.714 11.282zm-6.874 817.826c-41.236 0-75.596-13.746-116.832-20.616-27.49-6.872-54.98 0-75.596 27.49-13.746 13.746-61.852 54.98-61.852 54.98s6.872-27.49 13.746-61.852c6.872-54.98-6.872-89.342-6.872-89.342-75.596-68.726-123.704-171.812-123.704-281.772 0-206.174 164.94-371.114 371.114-371.114s371.114 164.94 371.114 371.114c0 206.174-164.94 371.114-371.114 371.114zm755.974-323.008c20.616-96.214 20.616-199.302-48.106-309.262C1030.874 11.286 831.572 4.414 776.592 11.286S714.74 25.032 714.74 25.032c89.342 48.106 164.94 130.576 206.174 219.92 27.49 61.852 41.236 130.576 48.106 199.302 6.872 96.216-27.49 213.048-89.342 288.644-13.746 13.746-20.616 27.49-41.236 41.236 0 0 6.872 0 27.49-6.872s20.616-6.872 48.106-13.746c0 0 109.96 109.96 199.302 137.45 0 0-82.47-116.832-54.98-199.302 0 6.872 109.96-61.852 137.45-185.558zm-900.296 164.94V224.334H501.69c75.596 0 116.832 48.106 116.832 116.832 0 54.98-34.362 96.216-68.726 103.086 41.236 6.872 82.47 54.98 82.47 109.96 0 68.726-41.236 123.706-116.832 123.706l-219.918-6.872zm247.41-316.132c0-34.362-20.616-54.98-54.98-54.98H371.114v116.832h116.832c34.362-6.872 54.98-34.362 54.98-61.852zm6.872 185.556c0-34.362-20.616-61.852-61.852-61.852H371.114v123.706h116.832c41.236 0 61.852-20.616 61.852-61.852z' })
        )
      );
    }
  }]);

  return AdpTheBridge;
}(_react2.default.Component);

AdpTheBridge.defaultProps = {
  viewBox: '0 0 1216 1043.776',
  height: '1em',
  width: '1.1650em'
};

exports.default = AdpTheBridge;


//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-icons/lib/adp/the-bridge.js
// module id = 561
// module chunks = 0 1 2 3 4 5 6